import React from 'react';
import PrayerButtonGrid from '../components/PrayerButtonGrid';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';


const categories = [
  'daily',
  'christian',
  'catholic',
  'father',
  'mother',
  'wife_prayer',
  'husband_prayer',
  'son_prayer',
  'daughter_prayer',
  'brother_prayer',
  'sister_prayer',
  'friend_prayer',
  'health_prayer',
  'finances_prayer',
  'world_prayer',
  'extended_family_prayer'
];

function HomePage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">Choose a Prayer</h1>
      <PrayerButtonGrid
        categories={categories}
        onSelect={(cat) => navigate(`/en/prayer/${cat}`, { state: { from: '/en' } })}
      />


      {/* ➕ More Prayers button */}
      <div className="text-center mt-3">
        <Button className="glass-button bg-transparent border-0" onClick={() => navigate('/more')}>
          More Prayers
        </Button>
      </div>

    </Container>
  );
}

export default HomePage;
